@let pedidosLength = pedidos().length;

<table>
    <tr [ngClass]="{ 'header': lugar() !== 'home' }">
        @if (editable()) {
        <th>Eliminar</th>
        }
        <th>Pedido</th>
        <th>Fecha</th>
        <th>1/2 Paleta 41</th>
        <th>Paleta 81</th>
    </tr>
    @for (pedido of pedidos(); track $index) {
    @let lineaKO = isLineaKO(pedido);
    @if (true) {
    <tr [ngClass]="{ 'row': $index != pedidosLength - 1 }">
        @if (editable()) {
        <td>
            @if (pedido.actionValor != 'A') {
            <input type="checkbox" [checked]="pedido.actionValor === 'B'" (click)="eliminarPedido(pedido)">
            <!-- <mat-checkbox class="center-checkbox" [(ngModel)]="selectAllCheckbox" (change)="selectAll($event)">
            </mat-checkbox> -->
            }
            @if (pedido.actionValor === 'A') {
            <i (click)="quitarLineaPedido($index)" class="bi bi-x-lg"></i>
            }
        </td>
        }
        <td>
            @if (!editable()) {
            {{ pedido.pedido }}
            }
            @if (editable()) {
            <mat-form-field [ngClass]="{ 'error': lineaKO }" class="example-full-width">
                <input matInput [(ngModel)]="pedido.pedido" type="text">
            </mat-form-field>
            }
        </td>
        <td>
            @if (!editable()) {
            {{ pedido.fecha | date: 'dd/MM/yyyy' }}
            }
            @if (editable()) {
            <mat-form-field [ngClass]="{ 'error': lineaKO }">
                <input class="default-input" [(ngModel)]="pedido.fecha" matInput [matDatepicker]="picker"
                    [matDatepickerFilter]="fechaDisponible" [disabled]="pedido.actionValor !== 'A'" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            }
        </td>
        @for (linea of pedido.lineas; track $index) {
        <td>
            @if (!editable()) {
            {{ linea.huecos }}
            }
            @if (editable()) {
            <mat-form-field [ngClass]="{ 'error': lineaKO }" class="example-full-width">
                <input matInput [(ngModel)]="linea.huecos" type="number" min="0">
            </mat-form-field>
            }
        </td>
        }
    </tr>
    }
    }
</table>